import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class Guest_Room_Settings extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();

		this.state = {

		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	handleChangeScreen = (screen_name) => {
		this.props.content_handler(screen_name, this.props.param);
	}

	handleControlParam = () => {
		this.props.receiver.getControlParam();
	}

	rcvGetControlParam = (ctrl_param) => {
		let param = this.props.param;
		param.ctrl_param = ctrl_param;
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Control_Param', param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			width: this.props.width - 40,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('guest_room_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ overflow: 'auto', paddingBottom: 60, height: this.props.height - 140 }}>
						<div style={button_style}>
							<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 60, textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }} onClick={() => this.handleChangeScreen('Rooms')}>
								<span>{this.props.receiver.getString('rooms')}</span>
							</div>
						</div>
						<div style={button_style}>
							<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 60, textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }} onClick={() => this.handleChangeScreen('Locations')}>
								<span>{this.props.receiver.getString('locations')}</span>
							</div>
						</div>
						<div style={button_style}>
							<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 60, textAlign: 'left', verticalAlign: 'top', marginLeft: 10, paddingTop: 15, paddingBottom: 15 }} onClick={this.handleControlParam}>
								<span>{this.props.receiver.getString('set_ctrl_param')}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}